import React from 'react';

import './TextBox.scss';
import Icon from 'Core/Components/Icon';
import { isValidNumber } from 'Core/Utils/Validation';
import Validator from 'RLX/Forms/Validator';

class TextBox extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      revealing: false,
      isFocus: false,
      hasBlurred: false
    };
    this.toggleRevealing = this.toggleRevealing.bind(this);
    this.startRevealing = this.startRevealing.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.stopRevealing = this.stopRevealing.bind(this);
    this.isNumberField = this.isNumberField.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getInputType = this.getInputType.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  getInputType () {
    const { fieldType, secret } = this.props;
    const { revealing } = this.state;
    return fieldType
      ? fieldType
      : secret && !revealing
        ? 'password'
        : 'text';
  }

  isNumberField () {
    return this.props.fieldType && this.props.fieldType === 'number';
  }

  handleKeyPress (event) {
    if (!this.isNumberField()) return;
    if (/[0-9]/.test(event.key)) return;
    else if (event.key.length > 1) return;
    else if (event.metaKey && ['a','c','x','v'].includes(event.key)) return;
    else if (event.key === '.' && event.target.value.indexOf('.') < 0) return;
    else if (event.key === '-' && event.target.value.indexOf('-') < 0) {
      const value = event.target.value;
      const nativeEvent = event.nativeEvent;
      const selectionStart = this.refs.input.selectionStart;
      console.log('allowing hyphen', { nativeEvent, selectionStart, value });
      return;
    } else {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  handleChange (event) {
    const { onChange, fieldType } = this.props;
    if (typeof onChange !== 'function') return;
    const value = event.target.value;
    switch (fieldType) {
      case 'optionalNumber':
      case 'number': {
        if (value === '') return onChange(null);
        if (!isValidNumber(value)) {
          event.stopPropagation();
          event.preventDefault();
        }
        const numberValue = typeof value === 'string' ? (value * 1) : value;
        return onChange(numberValue);
      }
      default:
        return onChange(value);
    }
  }

  handleBlur () {
    const isFocus = false;
    const hasBlurred = true;
    this.setState({ isFocus, hasBlurred });
  }

  handleFocus () {
    const isFocus = true;
    this.setState({ isFocus });
  }

  toggleRevealing () {
    const { revealing } = this.state;
    this.setState({ revealing: !revealing });
  }

  startRevealing () {
    const revealing = true;
    this.setState({ revealing });
  }

  stopRevealing () {
    const revealing = false;
    this.setState({ revealing });
  }

  render () {
    const { revealing, isFocus, hasBlurred } = this.state;
    const {
      value,
      label,
      onChange,
      required,
      secret,
      icon,
      tabIndex,
      disabled,
      children,
      validate,
      validatorMessage,
      className
    } = this.props;

    const inputType = this.getInputType();
    const labelClass = typeof value !== 'undefined' && value !== null
      && (typeof value === 'number' || value.length || (inputType === 'number' && value !== '' && value !== null))
        ? 'Passive'
        : '';

    return (
      <stack className={'Field TextBox-Wrapper' + (className ? ' ' + className : '')}>
        <div className={'TextBox' + (disabled ? ' disabled' : '')}>

          {!icon ? null : (
            <box className="TextBox-Icon">
              <Icon fa={icon + (isFocus ? ' active' : '')} />
            </box>
          )}

          <box className="TextBox-Field">
            {!label ? null : (
              <label className={labelClass}>
                {label}
                {!required ? '' : <span style={{ opacity: 0.4 }}>*</span>}
              </label>
            )}

            <input
              tabIndex={tabIndex || 0}
              value={typeof value !== 'undefined' && value !== null ? value : ''}
              type={inputType}
              disabled={disabled}
              ref="input"
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onKeyDown={this.handleKeyPress}
              onChange={this.handleChange}
            />
          </box>

          {!secret ? null : (
            <box
              className={'TextBox-Revealer' + (revealing ? ' active' : '')}
              onMouseDown={this.startRevealing}
              onMouseUp={this.stopRevealing}
              onMouseLeave={this.stopRevealing}
            >
              <Icon fa={revealing ? 'eye' : 'eye-slash'} />
            </box>
          )}

          {!disabled ? null : (
            <box className="TextBox-Attribute"><Icon fa="ban o3" /></box>
          )}

          {!children ? null : (
            <box className="TextBox-Attribute">{children}</box>
          )}
        </div>

        {!validate ? null : (
          <Validator
            enabled={hasBlurred}
            check={value}
            type={validate}
            message={validatorMessage}
          />
        )}
      </stack>
    );
  }
};

export default TextBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/TextBox/TextBox.jsx